﻿import React from 'react';

import { getEpiData } from '../../../Utils/epiHelpers';

//animation components
import LetterAnimation from './Animations/LetterAnimation';
import CheckmarkContainer from './Animations/CheckmarkContainer';
import HeartAnimation from './Animations/HeartAnimation';
import BooksAnimation from './Animations/BooksAnimation';
import MobilePhoneAnimation from './Animations/MobilePhoneAnimation';
import ComputerAnimation from './Animations/ComputerAnimation';

//text components
import AnimationText from './Texts/AnimationText';
import TextBlock from './Texts/TextBlock';


const SchoolDirectorsCampaignPage = (props) => {

    const heading1 = getEpiData('heading-1', props.mountRootId) || '';
    const subtext1 = getEpiData('subtext-1', props.mountRootId) || '';
    const heading2 = getEpiData('heading-2', props.mountRootId) || '';
    const subtext2 = getEpiData('subtext-2', props.mountRootId) || '';
    const heading3 = getEpiData('heading-3', props.mountRootId) || '';
    const subtext3 = getEpiData('subtext-3', props.mountRootId) || '';
    const heading4 = getEpiData('heading-4', props.mountRootId) || '';
    const subtext4 = getEpiData('subtext-4', props.mountRootId) || '';
    const heading5 = getEpiData('heading-5', props.mountRootId) || '';
    const subtext5 = getEpiData('subtext-5', props.mountRootId) || '';
    const uspheading1 = getEpiData('usp-heading-1', props.mountRootId) || '';
    const uspsubtext1 = getEpiData('usp-subtext-1', props.mountRootId) || '';
    const uspheading2 = getEpiData('usp-heading-2', props.mountRootId) || '';
    const uspsubtext2 = getEpiData('usp-subtext-2', props.mountRootId) || '';
    const uspheading3 = getEpiData('usp-heading-3', props.mountRootId) || '';
    const uspsubtext3 = getEpiData('usp-subtext-3', props.mountRootId) || '';
    const buttonText1 = getEpiData('buttontext-1', props.mountRootId) || '';
    const buttonLink1 = getEpiData('buttonlink-1', props.mountRootId) || '';
    const buttonText2 = getEpiData('buttontext-2', props.mountRootId) || '';
    const buttonLink2 = getEpiData('buttonlink-2', props.mountRootId) || '';
    const buttonText3 = getEpiData('buttontext-3', props.mountRootId) || '';
    const buttonLink3 = getEpiData('buttonlink-3', props.mountRootId) || '';
    const buttonText4 = getEpiData('buttontext-4', props.mountRootId) || '';
    const buttonLink4 = getEpiData('buttonlink-4', props.mountRootId) || '';
    const buttonText5 = getEpiData('buttontext-5', props.mountRootId) || '';
    const buttonLink5 = getEpiData('buttonlink-5', props.mountRootId) || '';


    const headings = [uspheading1, uspheading2, uspheading3];
    const texts = [uspsubtext1, uspsubtext2, uspsubtext3];

    return (

        <div className="school-directors-campaign">
            <div className="school-directors-campaign__hero">
                <section className="school-directors-campaign__section school-directors-campaign__letter">
                    <LetterAnimation />
                </section>

                <TextBlock heading={heading1} text={subtext1} buttonLink={buttonLink1} buttonText={buttonText1} />

                <section className="school-directors-campaign__section school-directors-campaign__usp">
                    <CheckmarkContainer headings={headings} texts={texts} />
                </section>
            </div>

            <section className="school-directors-campaign__section school-directors-campaign__heart">
                <AnimationText heading={heading2} text={subtext2} buttonLink={buttonLink2} buttonText={buttonText2} />
               <HeartAnimation />
            </section>

            <section className="school-directors-campaign__section school-directors-campaign__books">
                <BooksAnimation />
                <AnimationText heading={heading3} text={subtext3} buttonLink={buttonLink3} buttonText={buttonText3} />
            </section>

            <section className="school-directors-campaign__section school-directors-campaign__mobile-phone">
                <AnimationText heading={heading4} text={subtext4} buttonLink={buttonLink4} buttonText={buttonText4} />
                <MobilePhoneAnimation />
            </section>

            <div className="school-directors-campaign__footer">
                <section className="school-directors-campaign__section school-directors-campaign__computer">
                    <ComputerAnimation />
                </section>

                <TextBlock heading={heading5} text={subtext5} buttonLink={buttonLink5} buttonText={buttonText5} />
            </div>
        </div>
        )
   }
              
export default SchoolDirectorsCampaignPage;


